<template>
<div>
    <div class="vx-row">
        <!--FIN TIPOS PAGOS FACTURACION-->
        <!--FILE-->
        <div class="ml-4">Peso máximo: <b> {{ limiteMegas }} mb </b>
            <span class="text-danger text-right" v-if="muyPesado1"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ===> Peso del archivo actual: <b>{{ pesoArchivo1 }} mb</b> </span>
        </div>
        <div class="vx-col w-full mb-6">
            <p class="mt-1"></p>
            <div class="box-input" v-if="attachmentArray.length == 0 && ifSaveImagen == false">
                <div class=" box upload-container">
                    <input type="file" accept="image/*" name="fileEmpresa" id="fileEmpresa" v-on:change="uploadFiles" />
                </div>
                <br>
            </div>
            <!--BASE-->
            <div class="box-input" v-if="attachmentArray.length == 0 && ifSaveImagen == true">
                <div class="flex" style="justify-content: center;">
                    <div class="flex" style="flex-direction: column;">
                        <img id="img1" width="200" class="img-responsive mb-2 ml-1" :src="$data_book+'archivos/'+carpeta+'/'+imgOld" style="border-radius: 5px;margin: 0 auto;">
                        <small class="mt-1 ml-2">{{ imgOld }}</small>
                    </div>
                    <vs-button radius type="relief" size="large" @click="ifSaveImagen = false;" class="ml-2 mt-4" color="danger" icon="delete"></vs-button>
                </div>
            </div>
            <!--LOCAL-->
            <div class="flex" style="margin-top: -10px;" v-if="attachmentArray.length > 0">
                <div class="flex" v-for="(tr,key) in attachmentArray" :key="key" style="margin: 0 auto;">
                    <div class="flex" style="flex-direction: column;">
                        <img id="img1" v-if="tr.tipo == 'img'" width="200" class="img-responsive mb-2 ml-1" v-bind:src="tr.img" style="border-radius: 5px;margin: 0 auto;">
                        <img v-else style="width: 200px;" src="@/assets/images/file-icons/doc.png" />
                        <small class="mt-1 ml-2">{{ tr.name }}</small>
                    </div>
                    <vs-button radius size="large" type="filled" @click="removeItemFromArr(attachmentArray,tr)" class="ml-2 mt-4" color="danger" icon="delete"></vs-button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    components: {

    },
    data() {
        return {
            //VARIABLES IMAGEN
            attachmentArray: [],
            tipoFile: '',
            ifSaveImagen: false,
            imgOld: '',
            ifImagenBd: false,
            //FIN VARIABLES IMAGEN
            limiteMegas: this.pesoImagen, //maximo de megas permitido a subir en cada archivo
            bytes: 1048576,
            msjError: 'El peso del archivo excede el límite permitido, verifique antes de continuar.',
            porcentaje1: '',
            pesoArchivo1: '',
            muyPesado1: '',
            msj1: '',
        }
    },
    props: {
        modelName: {
            type: String,
            required: true
        },
        id: {
            type: Number,
            default: 0
        },
        ObjectSelected: {
            type: Object,
            default: function () {
                return {}
            }
        },
        carpeta: {
            type: String,
            default: ''
        },
        pesoImagen: {
            type: Number,
            default: 0
        }
    },
    created() {},
    mounted() {
        let me = this;
        me.attachmentArray = []
        if (me.id > 0) {
            me.imgOld = me.ObjectSelected.url
            if (me.imgOld) {
                me.ifSaveImagen = true
                me.ifImagenBd = true
            }
        } else {
            me.ifSaveImagen = false
        }
    },
    watch: {
        ObjectSelected(results) {
            this.ObjectSelected = results
            this.iniciar()
        },
        id(results) {
            this.id = results
            this.iniciar()
        },
    },
    methods: {
        limpiar(){
            let me = this;
            me.attachmentArray = []
            me.ifSaveImagen = false
        },
        iniciar() {
            let me = this;
            if (me.id > 0) {
                me.imgOld = me.ObjectSelected.url
                if (me.imgOld) {
                    me.ifSaveImagen = true
                    me.ifImagenBd = true
                }
            } else {
                me.ifSaveImagen = false
            }
        },
        removeItemFromArr(arr, item) {
            // let me = this;
            const i = arr.indexOf(item)
            arr.splice(i, 1)
            document.getElementById("fileEmpresa").value = ''
        },
        uploadFiles(event) {
            let me = this;
            var archivoTmp = document.getElementById("fileEmpresa").files[0];
            // console.log(archivoTmp.size)
            me.muyPesado1 = false;
            me.pesoArchivo1 = (archivoTmp.size / me.bytes).toFixed(2);
            // console.log(me.pesoArchivo1)
            if (me.pesoArchivo1 > me.limiteMegas) {
                me.muyPesado1 = true;
                me.$vs.notify({
                    text: me.msjError,
                    time: 5000,
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                })
                return
            }
            me.attachmentArray = []
            var archivo = document.getElementById("fileEmpresa").files[0];
            me.tipoFile = ""
            if (archivo.type == "image/png" || archivo.type == "image/gif" || archivo.type == "image/jpeg" || archivo.type == "image/jpg") me.tipoFile = "img"
            else me.tipoFile = "other"
            var reader = new FileReader();
            if (me) {
                reader.readAsDataURL(archivo);
                reader.onloadend = function () {
                    var cal = new Object();
                    cal.file = archivo
                    cal.img = reader.result
                    cal.tipo = me.tipoFile
                    cal.name = archivo.name
                    me.attachmentArray.push(cal)
                }
            }
            const file = event.target.files[0];
            this.$emit('input', file);
        },
    }
}
</script>

<style scoped>
.upload-container {
    position: relative
}

.upload-container input {
    border: 1px solid #92b0b3;
    background: #606569;
    outline: 2px dashed #92b0b3;
    outline-offset: -10px;
    padding: 100px 0px 100px 130px;
    width: 100%;
    color: white;
}

.upload-container input:hover {
    /* background: #2c78cf */
    background: #686a6b;
}

.upload-container:before {
    position: absolute;
    bottom: 50px;
    left: 23%;
    content: " Seleccione o arrastre un archivo aquí ";
    color: #f1f9fa;
    font-weight: 900
}

.upload-btn {
    margin-left: 300px;
    padding: 7px 20px
}
</style>
